<template>
  <div class="bq-product-jkmh">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      搭建区域/医院智慧服务门户，为患者提供便捷统一的线上智慧医疗服务。通过支付宝开发小程序/公众号或者微信服务号的门户入口，实现患者便利就医服务，覆盖患者诊前、诊中、诊后的全流程就医。包括预约诊疗、信息查询、在线缴费、便民服务等模块。
    </p>
    <div class="jkmh-decs">
      <InfoBox
        :col="2"
        :itemObj="item"
        v-for="item in datalist.desc"
        :key="item.advTitles"
      ></InfoBox>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="jkmh-adv">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in datalist.adv"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'jkmh',
  data() {
    return {
      datalist: {
        desc: [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1c_ydFYY1gK0jSZTEXXXDQVXa-96-96.png',
            advTitles: '预约诊疗',
            advDesc:
              '为患者提供线上门诊预约、当日挂号、医技预约、床位预约等便捷预约诊疗服务',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1Kw5XF.z1gK0jSZLeXXb9kVXa-96-96.png',
            advTitles: '信息查询',
            advDesc: '查看检验检查报告、排队叫号、手术进度、处方查询等信息',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1OoabF.T1gK0jSZFhXXaAtVXa-96-96.png',
            advTitles: '在线缴费',
            advDesc:
              '便捷缴纳门诊、住院、检查等费用，省去排队等候环节，提升患者就诊体验',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1TziaFYr1gK0jSZR0XXbP8XXa-96-96.png',
            advTitles: '便民服务',
            advDesc:
              '与院内停车场、点餐系统、院内导航、雨伞/轮椅/充电宝租借等便民服务进行对接，为患者提供统一服务',
          },
        ],
        adv: [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1CEycF5_1gK0jSZFqXXcpaXXa-86-84.png',
            advTitles: '轻量化应用',
            advDesc: '基于支付宝/微信小程序，用户无需下载任何应用，更加便捷',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1FQ1fF7T2gK0jSZFkXXcIQFXa-80-78.png',
            advTitles: '技术优势',
            advDesc:
              '采用数仓及大数据技术为医院搭建医疗数据仓库，同时基于数仓帮助医院各业务系统完成解耦，提升了院内应用可拓展性',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1qJKaF.H1gK0jSZSyXXXtlpXa-96-96.png',
            advTitles: '高可用性',
            advDesc:
              '基于微服务架构，将现有业务进行微服务化，应用系统高可用性达到99.99%',
          },
        ],
      },
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-jkmh {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .jkmh-decs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 60px 0 30px;

    .bq-infobox {
      width: 432px !important;
      margin-bottom: 60px;
    }
  }

  .jkmh-adv {
    display: flex;
    justify-content: space-between;
    .bq-infobox {
      width: 252px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    padding-bottom: 0;
    margin-bottom: 60px;
  }
}
</style>
